// START_MODULE pages_main_sections_contacts_contacts_tsx
// START_CONTRACT
// PURPOSE: Present the maintained public social channels of the Tomsk Data Science community.
// OPERATIONAL_CONTEXT: Final social section of the public static landing page.
// CONTRACT: Render Telegram, VK and LinkedIn destinations with matching icons, labels and scannable QR codes.
// KEYWORDS: social-links, telegram, vk, linkedin, qr
// COMPLEXITY: 2
// END_CONTRACT
import React from 'react';

import ContactItem from './components/contactItem/ContactItem';
import { ContactsWrapper } from './styled';

import telegram from 'assets/telegram_qr.png';
import vk from 'assets/vk_qr.png';
import linkedin from 'assets/linkedin_qr.png';

import LinkedInIcon from 'components/atoms/icons/LinkedInIcon';
import TelegramIcon from 'components/atoms/icons/TelegramIcon';
import VKIcon from 'components/atoms/icons/VKIcon';
import { ContentSectionContainer } from 'components/layout/contentSectionContainer/ContentSectionContainer';

import { Section } from 'routes/section';

const Contacts: React.FC = () => (
  <ContentSectionContainer id={Section.CONTACTS} type="middle">
    <h4>Мы в соцсетях</h4>
    <ContactsWrapper>
      <ContactItem qr={telegram} link="https://t.me/dataDinnersTomsk" linkText="Канал в телеграме">
        <TelegramIcon color="black" size={24} />
      </ContactItem>
      <ContactItem qr={vk} link="https://vk.com/tomskdatascience" linkText="Сообщество в ВК">
        <VKIcon color="black" size={24} />
      </ContactItem>
      <ContactItem qr={linkedin} link="https://www.linkedin.com/groups/12966826/" linkText="Группа в LinkedIn">
        <LinkedInIcon color="black" size={24} />
      </ContactItem>
    </ContactsWrapper>
  </ContentSectionContainer>
);

export default Contacts;

// END_MODULE pages_main_sections_contacts_contacts_tsx
